import { promiseSerial } from "@fokused-me/core";
import { usePromise, useSingleton } from "@fokused-me/web-ui";
import { fetchWithTimeout } from "../utils/common";

const init = () =>
   promiseSerial<string>(
      ["help/privacy.txt", "help/terms.txt"].map((url) => () => fetchWithTimeout(url).then((res) => res.text()))
   );

const usePolicyPromise = () => usePromise(init);

/* eslint-disable-next-line react-hooks/rules-of-hooks */
export const usePolicy = useSingleton(usePolicyPromise);
